import React, { useCallback } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string-for-all';
import NumberPagination from '@prisjakt/ui-number-pagination';
import { getSortedQuery } from '@prisjakt/product-collection-urls';
import { trackProductCollectionPagination } from '../../tracking';
import { PageInfo } from '../../../../types';

type Props = {
  pageInfo: PageInfo;
  total: number;
  alwaysShowStepButtons?: false;
};

const Pagination = ({ pageInfo, total, alwaysShowStepButtons }: Props) => {
  const { offset, limit } = pageInfo;
  const { search } = useLocation();
  const linkToPage = useCallback(
    (pageNumber: number) =>
      typeof limit === 'number'
        ? `?${queryString.stringify(
            getSortedQuery({
              ...queryString.parse(search.substr(1)),
              offset: pageNumber > 1 ? (pageNumber - 1) * limit : undefined,
            })
          )}`
        : '',
    [limit, search]
  );
  const currentPage =
    typeof offset === 'number' && typeof limit === 'number'
      ? Math.floor(offset / limit) + 1
      : 1;
  const onClickHandler = useCallback(
    ({ pageNumber, type }: { pageNumber: number; type: string }) =>
      trackProductCollectionPagination(currentPage, pageNumber, type),
    [currentPage]
  );
  if (typeof limit !== 'number' || typeof offset !== 'number' || limit === 0) {
    return null;
  }

  return (
    <NumberPagination
      currentPage={currentPage}
      onClick={onClickHandler}
      totalPages={Math.ceil(total / limit)}
      linkToPage={linkToPage}
      alwaysShowStepButtons={alwaysShowStepButtons}
    />
  );
};

export default Pagination;
